// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"cc1c4f00","685":"cc1c4f00","885":"cc1c4f00"}[chunkId] + ".chunk.css";
};